import React from 'react'
import { Popover } from "antd"
import "./style.scss"

const popoverStr = (text, num) => {
    if (text) {
        let textStr = `${text}`
        return (textStr.length < num ? textStr :
            <Popover content={<span dangerouslySetInnerHTML={{ __html: textStr }} />
            } trigger="hover" >
                <div style={{width: "100%"}} className="pover-text">{textStr.slice(0, num)}{textStr.length > num ? "..." : ""}</div>
            </Popover>)
    } else {
        return "-"
    }
}

export default popoverStr